import { useCanvasUi } from "@/pages/canvas/context/CanvasUiContext";
import { useReactFlow } from "@xyflow/react";
import { useCallback } from "react";

/**
 * Opens the same node context menu that right-click uses, anchored below a
 * toolbar element. Reuses the shared `nodeContextMenu` state so the rendered
 * menu is identical to the right-click menu — no per-node action wiring.
 */
export function useOpenNodeContextMenu() {
  const { setNodeContextMenu, reactFlowWrapperRef } = useCanvasUi();
  const reactFlowInstance = useReactFlow();

  return useCallback(
    (nodeId: string, anchor: HTMLElement) => {
      const wrapperRect = reactFlowWrapperRef.current?.getBoundingClientRect();
      if (!wrapperRect) return;

      const rect = anchor.getBoundingClientRect();
      const clientX = rect.left + rect.width / 2;
      const clientY = rect.bottom;
      const node = reactFlowInstance.getNode(nodeId);

      setNodeContextMenu({
        nodeId,
        nodeType: node?.type,
        screenX: clientX - wrapperRect.left,
        screenY: clientY - wrapperRect.top,
        clientX,
        clientY,
        flowPosition: reactFlowInstance.screenToFlowPosition({
          x: clientX,
          y: clientY,
        }),
        origin: "anchor",
      });
    },
    [reactFlowInstance, reactFlowWrapperRef, setNodeContextMenu],
  );
}
